import { Alert, AlertTitle, Button, Collapse, Stack } from '@mui/material';
import { useBackendHealth } from '../../hooks/useBackendHealth';

export default function BackendStatusBanner() {
  const { isBackendUp } = useBackendHealth();
  const isDev = import.meta.env.DEV;

  return (
    <Collapse in={!isBackendUp}>
      <Alert
        severity="error"
        sx={{ borderRadius: 0 }}
        action={
          <Stack direction="row" spacing={1}>
            <Button color="inherit" size="small" onClick={() => window.location.reload()}>
              Retry
            </Button>
          </Stack>
        }
      >
        {isDev ? (
          <>
            <AlertTitle>API server unavailable</AlertTitle>
            The admin panel cannot reach the backend on port 5000. Start it with{' '}
            <code>cd backend && npm run dev</code>, then click Retry or wait — we check every 5 seconds.
          </>
        ) : (
          <>
            <AlertTitle>Connection problem</AlertTitle>
            Unable to reach the server. Please try again in a moment.
          </>
        )}
      </Alert>
    </Collapse>
  );
}
